export enum MachineCategoryBaseColumnTypes {
  DEFAULT = 'DEFAULT',
  METADATA = 'METADATA',
  SIGNAL = 'SIGNAL',
}